import { render, staticRenderFns } from "./SithMesInventoryPackageList.vue?vue&type=template&id=0838f2c2&scoped=true&"
import script from "./SithMesInventoryPackageList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryPackageList.vue?vue&type=script&lang=js&"
import style0 from "./SithMesInventoryPackageList.vue?vue&type=style&index=0&id=0838f2c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0838f2c2",
  null
  
)

export default component.exports